// app/ningenie/lib/ningenie-user-server.ts
// baby: Server-side user ID management for API routes
// baby: When userId is provided from request context, use it directly

let serverUserId: string | null = null

// baby: set user ID for server-side execution context
export const setServerUserId = (userId: string | null) => {
  serverUserId = userId
}

// baby: get user ID for server-side execution
export const getServerUserId = (): string | null => {
  return serverUserId
}

